<p-multiSelect
  [options]="dropdownOptions"
  [(ngModel)]="selectedOptions"
  optionLabel="label"
  optionValue="value"
  placeholder="Column Options"
  [displaySelectedLabel]="false"
  [showHeader]="false"
  styleClass="column-options {{ styleClass }}"
  panelStyleClass="column-options-panel {{ panelStyleClass }}"
  (onChange)="onSelectItem($event)"
>
</p-multiSelect>
